import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=e51c56d4"
import script from "./ProvidersList.vue?vue&type=script&lang=js"
export * from "./ProvidersList.vue?vue&type=script&lang=js"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=e51c56d4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e51c56d4')) {
      api.createRecord('e51c56d4', component.options)
    } else {
      api.reload('e51c56d4', component.options)
    }
    module.hot.accept("./ProvidersList.vue?vue&type=template&id=e51c56d4", function () {
      api.rerender('e51c56d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProvidersList.vue"
export default component.exports